export default "__VITE_ASSET__8d10754a__"